import { render, staticRenderFns } from "./Pixels.vue?vue&type=template&id=365043aa&"
import script from "./Pixels.vue?vue&type=script&lang=js&"
export * from "./Pixels.vue?vue&type=script&lang=js&"
import style0 from "./Pixels.vue?vue&type=style&index=0&id=365043aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports